var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6258 21.174L17.2138 15.762C18.5638 14.214 19.3858 12.204 19.3858 9.99001C19.3858 5.13601 15.4498 1.20001 10.5898 1.20001C5.7298 1.20001 1.7998 5.13601 1.7998 9.99001C1.7998 14.844 5.7358 18.78 10.5898 18.78C12.8038 18.78 14.8198 17.958 16.3618 16.608L21.7738 22.02C21.8938 22.14 22.0438 22.2 22.1998 22.2C22.3558 22.2 22.5058 22.14 22.6258 22.026C22.8598 21.792 22.8598 21.408 22.6258 21.174ZM2.9998 9.99001C2.9998 5.80801 6.4078 2.40001 10.5898 2.40001C14.7718 2.40001 18.1798 5.80801 18.1798 9.99001C18.1798 14.172 14.7718 17.58 10.5898 17.58C6.4078 17.58 2.9998 14.178 2.9998 9.99001Z",
    fill: "#353EBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2ca38fa3e76f2222855884fa0bc5886d.svg";
export { ForwardRef as ReactComponent };